// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__DngAv","settings_card":"index_settings_card__nMqFF"};